/* Component rendered on the LocationsPage to display the 
   cover info for each Location
 * When clicked on it opens that Location's LocationPage */
import React from "react"
import { Card } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import styles from "../../styles/Characters.module.css"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { PostDropAdminOnly } from "../../components/PostDropdown"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

const LocationTop = (props) => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const { id, name } = props
  const history = useHistory()

  const handleEdit = () => {
    history.push(`/${localStorage.getItem("projectSlug")}/locations/${id}/edit`)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/locations/${id}/`)
        history.push(`/${localStorage.getItem("projectSlug")}/locations/`)
        toast.success(`Location "${name}" Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/locations/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        history.push(`/${localStorage.getItem("projectSlug")}/locations/`)
        toast.success(`Location "${name}" Deleted Successfully!`);
      }
    } catch (err) {}
  }
  return (
    <div className="mx-0">
      <Card className={`mx-1 text-center ${styles.Top}`}>
        <Row>
        <Col xs={{span: 8, offset: 2}} >
        <hr className={`mt-1 mb-0 ${styles.BreakWhite}`}/>
        </Col>
        </Row>
        <Link to={`/${localStorage.getItem("projectSlug")}/locations/${id}`}>
            <Row className={`d-flex align-items-center px-3 ${styles.TopText}`}>
              <Col className="mx-0 px-0" xs={1}>
              <i className={`fas fa-star ${styles.White}`}></i>
              </Col>
              <Col xs={10} className="px-0 text-center">
                <p className={` ${styles.Titlelist}`}> {name}</p>
              </Col>
              <Col xs={1} className="text-center mx-0 p-0">
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  (currentUser?.groups[0]?.name === "Admin" ||
                    currentUser?.groups[0]?.name === "Superadmin" ||
                    currentUser?.groups[0]?.name === "Admincreative") && (
                    <PostDropAdminOnly
                      handleEdit={handleEdit}
                      handleDelete={handleDelete}
                    />
                  )}
              </Col>
            </Row>
        </Link>
        <Row>
        <Col xs={{span: 8, offset: 2}} >
        <hr className={`mt-0 mb-1 ${styles.BreakWhite}`}/>
        </Col>
        </Row>
      </Card>
    </div>
  )
}

export default LocationTop
